/**
 * @module tax
 *
 * @description
 * The one rate the cart applies to an order's taxable items, worked out from the
 * merchant's tax types and the tax settings on the store.
 */
import type { IStore, ITaxType } from "../store/types";

/**
 * @description The percentage charged on taxable items: the sum of the percentage tax
 * types enabled on the store. A flat per-unit type, a deleted type and a type the
 * store does not enable add nothing.
 */
export const storeTaxPercent = (
  store: Pick<IStore, "taxes"> | null | undefined,
  taxTypes: ITaxType[]
): number => {
  const enabled = (store && store.taxes) || {};
  const percent = (taxTypes || []).reduce((sum, tax) => {
    if (
      !tax ||
      tax.isDeleted ||
      !tax.isRateNotFlat ||
      enabled[tax.id] !== true
    ) {
      return sum;
    }
    const amount = parseFloat(tax.amount);
    return amount > 0 ? sum + amount : sum;
  }, 0);
  // amounts carry up to five decimal places; a float sum can add noise beyond them
  return +percent.toFixed(5);
};
